import { ArrowDownRight, Crosshair, ScanLine } from "lucide-react";
import { PRODUCTS } from "@/data/products";
import { useState } from "react";

export default function KineticHero({ onExplore, onLedger }) {
  const [parallax, setParallax] = useState({ x: 0, y: 0 });
  const product = PRODUCTS[1];
  const handlePointerMove = (event) => {
    const bounds = event.currentTarget.getBoundingClientRect();
    setParallax({ x: (event.clientX - bounds.left - bounds.width / 2) / 28, y: (event.clientY - bounds.top - bounds.height / 2) / 28 });
  };
  return (
    <section className="hero" id="top" data-testid="kinetic-hero">
      <div className="hero-copy">
        <p className="eyebrow hero-eyebrow"><span className="status-dot" />GRAND OPENING / TECH VAULT IS OPEN</p>
        <h1 data-testid="hero-headline">
          <span className="hero-line">TECH VAULT</span>
          <span className="hero-line">IS OPEN.</span>
          <span className="hero-line">FIELD-GRADE</span>
          <span className="hero-line">ELECTRONICS.</span>
          <span className="hero-line">FOR THE</span>
          <span className="hero-line">LONG HAUL.</span>
        </h1>
        <p className="hero-intro">Rugged comms, hardened power, and precision carry systems. Sourced for the field, priced for the people who depend on it.</p>
        <div className="campaign-callout" data-testid="grand-opening-callout"><span>GRAND OPENING / ARMORY READY</span><strong>FIELD-GRADE ELECTRONICS FOR THE LONG HAUL.</strong><small>SOURCE / VERIFY / DISPATCH / TECH VAULT 2026</small></div>
        <div className="hero-actions">
          <button className="button button-primary" onClick={onExplore} data-testid="explore-armory-btn">EXPLORE ARMORY <ArrowDownRight size={17} /></button>
          <button className="button button-quiet" onClick={onLedger} data-testid="hero-pledge-btn">READ THE PLEDGE <span>0.10%</span></button>
        </div>
        <div className="hero-reassurance"><span>01</span><p>Every dispatch reserves 0.10% for programs helping troops after deployment.</p></div>
      </div>
      <div className="hero-visual-wrap">
        <div className="hero-visual" onPointerMove={handlePointerMove} onPointerLeave={() => setParallax({ x: 0, y: 0 })} style={{ "--parallax-x": `${parallax.x}px`, "--parallax-y": `${parallax.y}px` }} data-testid="hero-product-visual">
          <div className="hero-image-frame"><img src={product.imageUrl} alt="Apex Titan tactical chronograph" /></div>
          <div className="hero-reticle"><Crosshair size={46} strokeWidth={0.8} /><span>CALIBRATING</span></div>
          <div className="hero-coord hero-coord-top">[ 38°53′N / 77°00′W ]</div>
          <div className="hero-coord hero-coord-bottom">UNIT 02 / APEX TITAN / 300M</div>
          <div className="hero-scan"><ScanLine size={15} /> LIVE PRODUCT FEED</div>
        </div>
        <div className="hero-caption"><span>FEATURED UNIT / 02</span><b>APEX TITAN CHRONOGRAPH</b><span>$420.00 / TIER-1 SPECOPS</span></div>
      </div>
    </section>
  );
}
